// src/utils/statusPermissions.js
//
// FUENTE ÚNICA DE VERDAD de "qué rol puede poner cada estado de instrumento".
// Basado en la matriz enviada por la gerencia. Tanto la interfaz (pantalla de
// Ingresos y panel del técnico) como el candado de la base (trigger) deben
// respetar exactamente esta tabla.
//
// Roles del sistema: 'admin' | 'reception' | 'technician' | 'lab_manager'.

// "ADM" (administrativo / oficina de arriba). Decisión tomada: ADM = admin.
// 👉 Si la oficina también entra con el rol `reception`, sumalo a esta lista.
export const ADM_ROLES = ["admin", "administrative_assistant"];
const ADMIN_ONLY = ["admin"];

// El técnico calibra; el jefe de laboratorio TAMBIÉN calibra, así que
// comparten los estados del trabajo de calibración.
const TEC_Y_JEFE = ["technician", "lab_manager", "admin"];

// Estados del jefe de laboratorio; el administrador hereda esa capacidad.
const SOLO_JEFE = ["lab_manager", "admin"];

// Matriz: estado -> roles que pueden SETEARLO manualmente.
export const STATUS_ROLE_MATRIX = {
  // --- Oficina (ADM) ---
  pending_reception: ADM_ROLES, // "Pendiente de recepción"
  active: ADM_ROLES,            // "En depósito"
  remitted: ADM_ROLES,          // "En espera de entrega"

  // --- Laboratorio: técnico y jefe ---
  in_progress: TEC_Y_JEFE,
  calibrated: TEC_Y_JEFE,
  with_certificate: TEC_Y_JEFE,
  without_certificate: TEC_Y_JEFE,

  // --- Exclusivos del jefe de laboratorio ---
  paused: SOLO_JEFE,
  rejected: SOLO_JEFE,
  reviewed: SOLO_JEFE,

  // --- Cierre (ADM) ---
  delivered: ADM_ROLES,
  delivered_with_certificate: ADM_ROLES,
  delivered_without_certificate: ADM_ROLES,
  delivered_not_calibrated: ADM_ROLES,
  delivered_not_repaired: ADM_ROLES,
  delivered_repaired: ADM_ROLES,
  cancelled: ADMIN_ONLY,
};

// Estados que pone el SISTEMA en automático (nadie los elige a mano).
// "Listo para remitar" se dispara solo cuando el jefe marca "Revisado".
export const AUTO_STATUSES = ["ready_to_remit"];

// Escape hatch: roles con permiso TOTAL (bypass de la matriz).
// VACÍO = matriz estricta, tal como pidió la gerencia. Para darle "llave
// maestra" a un rol, agregalo acá (p. ej. un futuro 'superadmin').
export const BYPASS_ROLES = [];

// ¿Puede este rol poner este estado a mano?
export function canSetStatus(role, status) {
  if (!role || !status) return false;
  if (BYPASS_ROLES.includes(role)) return true;
  if (AUTO_STATUSES.includes(status)) return false; // automático
  const allowed = STATUS_ROLE_MATRIX[status];
  // Estado no gobernado por la matriz: no lo bloqueamos (evita romper flujos).
  if (!allowed) return true;
  return allowed.includes(role);
}

// Lista de estados que un rol puede setear (útil para filtrar dropdowns).
export function settableStatusesFor(role) {
  return Object.keys(STATUS_ROLE_MATRIX).filter((s) => canSetStatus(role, s));
}
